import React, { Component, Suspense } from 'react';
import LoaderFullPage from "./LoaderFullPage.jsx";

export default class LadderSuspense extends Component {
	static defaultProps = {
		fallback: <LoaderFullPage />
	};

	render() {
		const { children, ...props } = this.props;
		return (
			<Suspense {...props}>
				{children}
			</Suspense>
		);

	}
}